module.exports = __webpack_public_path__ + "static/img/broadcast-thumb-four.ed7bf3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/broadcast-thumb-four.png
// module id = OZ6B
// module chunks = 0